import {useEffect, useState} from 'react';
import {ServiceLocator} from "../service-locator";
import {UiState} from "../services/ui-state";

export const useUiService = () => {
	const [state, setState] = useState<UiState>(ServiceLocator.uiService.toState());

	useEffect(() => {
		console.log('use-ui-service effect executed');

		ServiceLocator.uiService.addEventListener(() => {
			setState(ServiceLocator.uiService.toState());
		});
	}, []);

	return {uiService: ServiceLocator.uiService, uiState: state};
}
